import { TransformInt } from '../../../decorators/transform-int.decorator';

import { CreateStatusTrackingPriorityDto } from './create-status-tracking-priority.dto';

/**
 * Update status tracking priority DTO
 */
export class UpdateStatusTrackingPriorityDto extends CreateStatusTrackingPriorityDto {
	@TransformInt()
	id!: number;
}
